import modals from 'webmodals/modals';
import BasicAutoQueryController from 'servicestack/auto-query/auto-query.controller';
import templateUrl from 'emun.retailer/paid-invoices.htm';
import AutoQuery from 'servicestack/auto-query/auto-query';

export default class RetailerPaymentHistoryController extends BasicAutoQueryController {
	constructor() {
		super();
		let $ctrl = this;
	}
	$onInit() {
		const $ctrl = this;
		super.$onInit && super.$onInit();
		$ctrl.query = new AutoQuery($ctrl.getQueryOptions());
	}
	getQueryOptions() {
		const $ctrl = this;
		return {
			url: 'QueryInvoicePayments.json?',
			pageSize: 12,
			criteria: {
				RetailerId: this.retailerId
			},
			orderBy: '-DateEntered',
			//append: true,
			autoLoad: true,
			hideLeftNav: true,
			filters: [
				{ date: "DateEntered", title: "Payment Date" },
				{ date: "InvoiceDate", title: "Invoice Date" }
			],
			sortOptions: {
				'TransactionNo': 'Transaction #: Low to High',
				'-TransactionNo': 'Transaction #: High to Low',
				'DateEntered': 'Date: Newest',
				'-DateEntered': 'Date: Oldest'
			}
		};
	}
	delete(payment) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure?", "Delete Payment")
			.result.then(function () {
				return $ctrl.bus
					.send("DeleteInvoicePayment", payment)
					.then(function (response) {
						$ctrl.query.load(true);
					});
			});
	}
	showInvoices(options) {
		return modals.open(angular.extend({
			size: 'md',
			//placement: 'right',
			//backdrop: false,
			templateUrl,
			resolve: {
				options: () => options
			},
			bindToController: true,
			controller: function (options) {
				let $ctrl = this;
				$ctrl.query = new AutoQuery({
					url: 'QueryInvoicePayments.json?TransactionNo=' + options.transactionNo,
					pageSize: 100,
					orderBy: 'InvoiceNumber',
					append: true,
					autoLoad: true,
					sortOptions: {
						'InvoiceNumber': 'Invoice #: High to Low',
						'-InvoiceNumber': 'Invoice #: Low to High',
						'DateEntered': 'Date: Newest',
						'-DateEntered': 'Date: Oldest'
					}
				});
				$ctrl.dismiss = function () {
					const $ctrl = this;
					$ctrl.$dismiss();
				};
			},
			controllerAs: '$ctrl'
		}, (options || {}).modal)).result;
	}
};